<!--
 * @Author: lan.h
 * @Date: 2022-02-22 09:56:19
 * @LastEditors: lan.h
 * @LastEditTime: 2022-03-28 11:10:41
 * @Description: 热门标签
-->
<template>
  <div class="hotag" v-if="hotag.length > 0">
    <div class="mode-title">
      <span class="title-p">热门标签</span>
      <a  class="more" @click="toAllTag"
          onclick="_czc.push(['_trackEvent', '首页(新)', '右侧热门标签(查看更多)', '点击量'])">查看更多</a>
    </div>
    <div class="hotag-content">
      <a  v-for="item, index in hotag" :key="index" @click="toArticelList(item)" 
          onclick="_czc.push(['_trackEvent', '首页(新)', '右侧热门标签(标签)', '点击量'])">
        <img :src="$store.state.static_img_url+'pic/vcbeat/tag.png'">{{item.name}}
      </a>
    </div>
  </div>
</template>

<script>
import { commontag } from "../../service";
export default {
  data() {
    return {
      hotag: [],
      loading: false
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.loading = true
      let res = await commontag( {
        full: false,
        size: 10
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.code == 0) {
        this.$set(this.$data, 'hotag', res.data ? res.data.hotTags : [])
        this.loading = false
      } else {
        this.$Message.error(res.msg)
      }
    },
    toArticelList(item) {
       const href = this.$store.state.index2_path + '/articleList?tag=' + item.id
        window.open(href, '_blank')
    },
    toAllTag() {
       const href = this.$store.state.index2_path + '/mediaTagList'
        window.open(href, '_blank')
    }
  }
}
</script>

<style lang="stylus" scoped>
.hotag
  &-content
    display flex 
    flex-flow wrap
    a 
      margin-top 16px
      background #FFF4EA
      border-radius 13px
      margin-right 6px
      font-size 14px
      font-weight 500
      color #FF8824
      line-height 1
      padding 6px 10px   
      display flex
      align-items center
      img 
        margin-right 6px
      &:hover
        color #FF6600
  .more
    font-size 14px
    font-weight 500
    &:hover 
      color #FF6600
</style>